import Headroom from "headroom.js";

 // import Swiper bundle with all modules installed
 import Swiper, { Scrollbar, Thumbs, EffectFade, FreeMode } from 'swiper';

 import Drift from 'drift-zoom';
 
var $device = '';
/*
* dispatcher 全ページ共通
*/
dispatcher('.', function () {

    (function () {
        var headroom;

        /**
         * loading
         */
         const $body = document.getElementsByTagName('body')[0];
         $body.classList.add('is-loading');
     
         window.addEventListener('load', function(){
             $body.classList.remove('is-loading');
         });

        /*
        *	メディアクエリー
        */
        const mediaQueryList = window.matchMedia('(min-width:922px)');

        const ScreenListener = (event) => {
          // リサイズ時に行う処理
          if (event.matches) {
            // 922px以上
            console.log('PC用ブレークポイント用処理');
            $device = 'pc';
            console.log( $device );
            //headroom
            var headroomElement = document.getElementById('masthead');
            var headroomOptions = {
                tolerance : {up: 10,down: 10},
                onUnpin : function() {
                    
                }
            };
        
            headroom = new Headroom(headroomElement, headroomOptions);
            headroom.init();

          } else {
            
            // 922px未満
            console.log('SP用ブレークポイント用処理');
            
            $device = 'sp';
            console.log( $device );
            // headroom解除
            if( headroom !== undefined ){
                headroom.destroy();
            }
          }
        };
        
        // リスナー登録
        mediaQueryList.addListener( ScreenListener );
        
        // 初期化処理
        ScreenListener( mediaQueryList );

        // FilterMenu
        let filterSelect = document.getElementsByClassName('filterMenu');
        for ( let filter of filterSelect ){
            filter.addEventListener('change', function(){
                var index = this.selectedIndex;
                var value = this.options[index].value;
                //console.log(value);
                location.href = value;
            }, false);
        }

    })();

});


// トップページ
dispatcher('^/$', function () {
    (function () {
        
        const swiper = new Swiper('.swiperlatestNews', {
            // Install modules
            modules: [Scrollbar, FreeMode],
            speed: 500,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            slidesOffsetAfter: 32
        });

        const swiper2 = new Swiper('.swiperlatestProducts', {
            // Install modules
            modules: [Scrollbar, FreeMode],
            speed: 500,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            slidesOffsetAfter: 32
        });
        
    })();
});



// ブランドページ
dispatcher('^/brands/.', function () {
    (function () {
        //console.log('swipered');
        // Now you can use Swiper

        const swiper = new Swiper('.swiperbrandsProducts', {
            // Install modules
            modules: [Scrollbar, FreeMode],
            speed: 500,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            slidesOffsetAfter: 32
        });

        const swiper2 = new Swiper('.swiperbrandsNews', {
            // Install modules
            modules: [Scrollbar, FreeMode],
            speed: 500,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            slidesOffsetAfter: 32
        });
        
    })();
});



// 第一引数はURLのパス部分にマッチする正規表現 
dispatcher('^/products-and-service/(.+)/.', function () {
    (function () {
        //console.log('swipered');
        // Now you can use Swiper
        const swiper = new Swiper('.swiperbrandsProducts', {
            // Install modules
            modules: [Scrollbar, FreeMode],
            speed: 500,
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            slidesPerView: 'auto',
            spaceBetween: 0,
            freeMode: true,
            slidesOffsetAfter: 32
        });

        

        // 商品サムネイル
        const thumbs = new Swiper('.swiperThumbs', {
            // Install modules
            //modules: [Thumbs],
            speed: 500,
            slidesPerView: 5,
            //centeredSlides: true,
            slideToClickedSlide: true,
            spaceBetween: 12,
            threshold: 5
            //freeMode: true,
            //centeredSlidesBounds: true,
        });

        // 商品写真
        const photos = new Swiper('.swiperPhotos', {
            // Install modules
            modules: [Thumbs, EffectFade],
            allowTouchMove: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            speed: 500,
            //slidesPerView: 1,
            spaceBetween: 0,
            thumbs: {
                swiper: thumbs,
            },
            /*
            controller: {
                control: thumbs
            }
            */
            
            //freeMode: true,
            //centeredSlidesBounds: true,
        });

        //drift拡大

        //const driftImgs = document.querySelectorAll('.drift-image');
        //console.log( driftImgs );


        if( $device == 'sp' ){
            Array.from(document.querySelectorAll('.drift-image'), img => {
                new Drift(img, {
                    inlinePane: true,
                    inlineOffsetX: -5,
                    inlineOffsetY: -50,
                    zoomFactor: 2,
                    containInline: true,
                    hoverBoundingBox: false,
                    touchBoundingBox: false,
                    showWhitespaceAtEdges: false,
                });
            })
        }

        //const pane = document.querySelector('.drift-pane');
        /*
        driftImgs.map(img => {
            new Drift(img, {
                inlinePane: true,
                inlineOffsetY: -85,
                zoomFactor: 2,
                containInline: false
            });
        });
        */

        /*
        new Drift(document.querySelector('.drift-image'), {
            inlinePane: true,
            inlineOffsetY: -85,
            zoomFactor: 2,
            containInline: false
          });
        */
        
    })();
});


/*
// 第一引数はURLのパス部分にマッチする正規表現 
dispatcher('^/hoge|^/huga', function () {
    (function () {
        

        
    })();
});
*/




/*	function dispatcher
*	URLパスに応じて実行スクリプトを制御
*	第一引数はURLのパス部分にマッチする正規表現
*/
function dispatcher (path, func) {
    dispatcher.path_func = dispatcher.path_func || []
    if (func) return dispatcher.path_func.push([path, func]);
    for(var i = 0, l = dispatcher.path_func.length; i < l; ++i) { // >
        var func = dispatcher.path_func[i];
        var match = path.match(func[0]);
        match && func[1](match);
    };
};
dispatcher(location.pathname);